export enum MarginTransactionDirection {
  Spot = 'spot',
  Derivatives = 'derivatives',
}

export enum MarginOrdersType {
  Position = '0',
  Orders = '1',
  History = '2',
  Transfers = '3  ',
  BalanceAdjustments = '4',
}

export enum MarginPositionDetailsStep {
  Root = 0,
  ManageProtectionOrders = 1,
  ClosePosition = 2,
  PartialClosePosition = 3,
  RemoveProtectionOrder = 4,
}

/* Margin History Types */
export type MarginHistoryDirection = 'BUY' | 'SELL';
export type MarginHistoryEvent = 'opened' | 'closed' | 'partial_closed' | 'placed' | 'edited' | 'cancelled' | 'failed';

export type MarginOrderCloseType = 'market' | 'takeProfit' | 'stopLoss';
